import React, { useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import clientConfig from "../../config/client";
import renderField from "./renderer/index.jsx";
import FileExplorerModal from "./FileExplorerModal.jsx";
import TextField from "@material-ui/core/TextField";
import { Box, Checkbox } from "@material-ui/core";
import ImageUploaderModal from "../Modal/ImageUploaderModal";
// import parse from "html-react-parser";
// import { passwordRenderer } from "./renderer/_password";
import ChildAgesForm from "../Views/ChildAgesForm.jsx";
import ImageModal from "./ImageModal";
import PdfModal from "./PdfModal";
import FileUploaderModal from "../Modal/FileUploaderModal";

const firstTdCss = {
    marginLeft: "80px",
    position: "absolute",
    width: "350px",
    borderBottom: "none",
};

const secondTdCss = {
    marginLeft: "80px",
    position: "absolute",
    width: "350px",
    borderBottom: "none",
};

const cssTdGeneral = {
    width: "250px",
    borderBottom: "none",
    paddingTop: "45px",
};

const styleTdAll = {
    width: "250px",
    borderBottom: "none",
};

const styleTdLine = {
    borderBottom: "none",
};

const styleTdLineModifierFirst = {
    borderBottom: "none",
    padding: "0 0 0 140px",
};

const styleTdLineModifierSecond = {
    borderBottom: "none",
    padding: "0 0 30px 140px",
};

const styleTdLineModifierGeneral = {
    borderBottom: "none",
    paddingTop: "45px",
};

const styleFeat__button = {
    outline: "none",
    border: "none",
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "#00aed2",
    fontSize: "15px",
    margin: "10px 60px",
    cursor: "pointer",
};

const contImageFiles = {
    display: "flex",
    columnGap: "10px",
    margin: "15px 0px",
    flexWrap: "wrap",
};

const styleImageFiles = {
    boxShadow: "1px 1px 2px 1px rgba(10, 10, 10, .2)",
    width: "120px",
    height: "150px",
    objectFit: "contain",
    cursor: "pointer",
};

const styleFigureImg = {
    display: "inline-block",
    margin: "10px",
    width: "120px",
    wordBreak: "break-all",
};

const generalModifierTdArr = [
    "fix_count_children",
    "fix_extra_bed",
    "fix_count_babies",
    "fix_children_extra_bed",
    "fix_cradle",
];

const firstModifierTdArr = [
    "fix_count_children_date_new",
    "fix_extra_bed_date_new",
    "fix_count_babies_date_new",
    "fix_children_extra_bed_date_new",
    "fix_cradle_date_new",
];

const secondModifierTdArr = [
    "fix_count_children_new",
    "fix_extra_bed_new",
    "fix_count_babies_new",
    "fix_children_extra_bed_new",
    "fix_cradle_new",
];

const PropertiesList = (props) => {
    const {
        fieldUpdateHandler,
        errorFields,
        fields,
        mutable,
        item,
        ignoreEditable,
        relationsDataSource,
        defaultPaymentTypes,
        defaultServices,
        serviceCategories,
        defaultValues,
        updateImage,
        defaultRoomFeatures,
        defaultRoomTypes,
        updateCurRateFromBase,
        allItems,
        inheritStarted,
        unusedServicesHidden,
        defaultRates,
        cancellationPolicy,
        defaultHotels,
        placesSale,
        interfaceTypes,
        defaultDiscountTypes,
        imageAcceptExtensions,
        rates,
        setUpdateRates,
        refund,
        hotelId,
    } = {
        ...props,
    };

    const [featName, setFeatName] = useState(item.icon);
    const [featModalVisible, setFeatModalVisible] = useState(false);
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = useState("");
    const [files, setFiles] = useState(item.files || []);
    const [pdfModalVisible, setPdfModalVisible] = useState(false);

    const { locale } = { ...clientConfig };
    const sourceFields = {};
    const imgUrl = window.location.origin + "/feature_icons/";
    const handleImageClick = (url) => {
        const parsUrl = new URL(url);
        const fileName = parsUrl.pathname.substring(1);
        const isPdf = fileName.endsWith(".pdf");

        setSelectedImageUrl(url);

        if (isPdf) {
            setPdfModalVisible(true);
        } else {
            setImageModalVisible(true);
        }
    };

    const handleCloseImageModal = () => {
        setImageModalVisible(false);
        setSelectedImageUrl("");
    };

    const rows = Object.entries(fields)?.map((entry) => {
        const [fieldName, fieldConfig] = [...entry];

        if (
            !item?.cashback_active &&
            [
                "cashback_percent",
                "cashback_stay_date_from",
                "cashback_stay_date_to",
                "cashback_booking_date_from",
                "cashback_booking_date_to",
                "cashback_day_accrual",
            ].includes(fieldName)
        ) {
            return null;
        }

        //Скрыли лишние поля в категории
        if (
            ["cradle_capacity", "external_id"].includes(
                fieldName,
            )
        ) {
            return null;
        }
        if (
            fieldName === "guarantees_payment_methods" ||
            fieldName === "child_ages"
        ) {
            return;
        }

        if (props?.thisPurchasedServices && fieldName === "reservation") {
            return;
        }

        if (fieldName === "images" && props?.thisRoomType) {
            return (
                <TableRow key={fieldName}>
                    <TableCell style={{ borderBottom: "none" }}>
                        <ImageUploaderModal
                            roomTypeId={item.id}
                            imagesArr={JSON.parse(item?.images) || []}
                        />
                    </TableCell>
                </TableRow>
            );
        }

        if (fieldName === "files") {
            return (
                <TableRow key={fieldName}>
                    <TableCell style={{ borderBottom: "none" }}>
                        Документы
                    </TableCell>
                    <TableCell style={{ borderBottom: "none" }}>
                        <div style={contImageFiles}>
                            {files.map((url, index) => {
                                const parsUrl = new URL(url.link);
                                const fileName = parsUrl.pathname.substring(1);
                                const isPdf = fileName.endsWith(".pdf");
                                return (
                                    <figure style={styleFigureImg}>
                                        <img
                                            style={styleImageFiles}
                                            key={url.link}
                                            src={
                                                isPdf
                                                    ? "/img/ico_pdf_file.png"
                                                    : url.link
                                            }
                                            alt={
                                                isPdf
                                                    ? `PDF файл ${index + 1}`
                                                    : `Изображение ${index + 1}`
                                            }
                                            onClick={() =>
                                                handleImageClick(url.link)
                                            }
                                        />
                                        <figcaption
                                            style={{
                                                marginTop: "5px",
                                                fontSize: "14px",
                                                color: "#555",
                                            }}
                                        >
                                            {fileName}
                                        </figcaption>
                                    </figure>
                                );
                            })}
                        </div>
                        <FileUploaderModal
                            imagesArr={files || []}
                            entity="refund"
                            entityId={item.id}
                            onUpdateFiles={setFiles}
                        />
                    </TableCell>
                </TableRow>
            );
        }

        if (fieldName === "created_at") return;
        let value = item && item[fieldName];
        let field;
        if (ignoreEditable) {
            field = {
                ...fieldConfig,
                name: fieldName,
                editable: ignoreEditable,
                value,
            };
        } else {
            field = Object.hasOwnProperty.call(fieldConfig, "editable")
                ? {
                      ...fieldConfig,
                      name: fieldName,
                      value,
                  }
                : {
                      ...fieldConfig,
                      name: fieldName,
                      editable: ignoreEditable,
                      value,
                  };
        }

        ["restrictionMax", "restrictionMin"].forEach((restrictionType) => {
            if (Object.hasOwnProperty.call(field, restrictionType)) {
                const restrictionFieldName = field[restrictionType];
                field[restrictionType] = item[restrictionFieldName];

                field.restrictionFieldName = restrictionFieldName;
            }
        });

        if (fieldConfig.target) {
            if (!value) {
                value = Object.keys(fieldConfig.values)[0];
            }

            sourceFields[fieldName] = {
                ...fieldConfig.values[value],
            };
        }

        if (fieldConfig.source) {
            field = {
                ...field,
                ...sourceFields[fieldConfig.source],
            };
        }

        // if (fieldConfig.type === "html" && field.value) {
        //     const parsedFromHtml = parse(field.value);
        //     field.value = parsedFromHtml;
        // }

        // init relation routes between current item and other entity type
        if (fieldConfig.type === "relation") {
            const id = (item && item.id) || 0;
            field.dataSource = relationsDataSource(id, fieldConfig.entity);
        }

        const label = fieldConfig.labels
            ? fieldConfig.labels[locale]
            : fieldName;

        if (fieldName === "inheritance") {
            field = {
                ...fieldConfig,
                name: fieldName,
                value: {
                    base_rate_id: item.base_rate_id,
                    inheritance_value: item.inheritance_value,
                    inheritance_operation: item.inheritance_operation,
                    inheritance_unit: item.inheritance_unit,
                    inheritance_stops: item.inheritance_stops,
                    inheritance_discount_check: item.inheritance_discount_check,
                },
            };
        }

        let css = styleTdAll;
        let cssLine = styleTdLine;

        if (firstModifierTdArr.includes(fieldName)) {
            css = firstTdCss;
            cssLine = styleTdLineModifierFirst;
        } else if (secondModifierTdArr.includes(fieldName)) {
            css = secondTdCss;
            cssLine = styleTdLineModifierSecond;
        } else if (generalModifierTdArr.includes(fieldName)) {
            css = cssTdGeneral;
            cssLine = styleTdLineModifierGeneral;
        }

        if (props?.thisFeatures && fieldName === "icon") {
            return (
                <TableRow key={fieldName}>
                    <TableCell style={css}>{label}</TableCell>
                    <TableCell style={cssLine}>
                        <img
                            style={{ width: "32px" }}
                            src={`${imgUrl}${featName}`}
                            alt={`${featName}`}
                        />
                    </TableCell>
                </TableRow>
            );
        }

        return (
            <TableRow key={fieldName}>
                <TableCell style={css}>{label}</TableCell>
                <TableCell style={cssLine}>
                    {renderField(
                        field,
                        fieldUpdateHandler,
                        errorFields,
                        mutable,
                        defaultPaymentTypes,
                        defaultServices,
                        serviceCategories,
                        defaultValues,
                        updateImage,
                        defaultRoomFeatures,
                        defaultRoomTypes,
                        updateCurRateFromBase,
                        allItems,
                        inheritStarted,
                        unusedServicesHidden,
                        defaultRates,
                        cancellationPolicy,
                        defaultDiscountTypes,
                        imageAcceptExtensions,
                        defaultHotels,
                        placesSale,
                        interfaceTypes,
                        rates,
                        setUpdateRates,
                        item?.id,
                        refund,
                        hotelId,
                    )}
                </TableCell>
            </TableRow>
        );
    });

    const handleModal = (e) => {
        e.preventDefault();
        setFeatModalVisible((pr) => !pr);
    };

    const handleInputChange = (index, field, value) => {
        const updated = {
            ...item.guarantees_payment_methods,
            [index]: {
                ...item.guarantees_payment_methods[index],
                [field]: value,
            },
        };

        fieldUpdateHandler("guarantees_payment_methods", updated);
    };

    if (props?.payment_methods) {
        props.payment_methods.forEach((p, i) => {
            const row = (
                <TableRow key={i + 456}>
                    <TableCell style={styleTdAll}>{p}</TableCell>
                    <TableCell style={styleTdLine}>
                        <span style={{ color: "#26ade4" }}>Тип гарантии</span>
                        <Box width={"45%"}>
                            <TextField
                                fullWidth
                                value={
                                    item?.guarantees_payment_methods?.[i + 1]
                                        ?.guaranteed ?? ""
                                }
                                onChange={(e) =>
                                    handleInputChange(
                                        i + 1,
                                        "guaranteed",
                                        e.target.value,
                                    )
                                }
                            />
                        </Box>
                    </TableCell>
                    <TableCell style={styleTdLine}>
                        <span style={{ color: "#26ade4" }}>Метод платежа</span>
                        <Box width={"45%"}>
                            <TextField
                                fullWidth
                                value={
                                    item?.guarantees_payment_methods?.[i + 1]
                                        ?.method ?? ""
                                }
                                onChange={(e) =>
                                    handleInputChange(
                                        i + 1,
                                        "method",
                                        e.target.value,
                                    )
                                }
                            />
                        </Box>
                    </TableCell>
                </TableRow>
            );
            rows.push(row);
        });
    }

    if (props?.thisInterface) {
        rows.push(
            <ChildAgesForm
                item={item}
                fieldUpdateHandler={fieldUpdateHandler}
            />,
        );
    }

    return (
        <>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableHead></TableHead>
                    <TableBody>{rows}</TableBody>
                </Table>
            </TableContainer>
            {props?.thisFeatures && (
                <>
                    <button style={styleFeat__button} onClick={handleModal}>
                        Установка иконки
                    </button>
                    <FileExplorerModal
                        featModalVisible={featModalVisible}
                        setFeatModalVisible={setFeatModalVisible}
                        featName={featName}
                        setFeatName={setFeatName}
                        updateImage={updateImage}
                    />
                </>
            )}
            <ImageModal
                open={imageModalVisible}
                onClose={handleCloseImageModal}
                imageUrl={selectedImageUrl}
            />

            <PdfModal
                open={pdfModalVisible}
                onClose={() => setPdfModalVisible(false)}
                pdfUrl={selectedImageUrl}
            />
        </>
    );
};

PropertiesList.defaultProps = {};
PropertiesList.propTypes = {
    fields: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    errorFields: PropTypes.object,
    fieldUpdateHandler: PropTypes.func,
    setUpdateRates: PropTypes.func,
    ignoreEditable: PropTypes.bool,
    relationsDataSource: PropTypes.func,
    getDefaultValues: PropTypes.func,
    defaultValues: PropTypes.array,
    loadedPaymentTypes: PropTypes.bool,
    loadedServices: PropTypes.bool,
    unusedServicesHidden: PropTypes.object,
};

export default PropertiesList;
